function FaceHide() {
  return <img src={"./facehide.PNG"} className="App-logo" alt="logo" />;
}

export default FaceHide;
